<template>
  <div>
    <section class="section is-title-bar">
      <v-row justify="space-between">
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <p class="title is-5">Warehouse Mapping</p>
            </div>
          </div>
        </div>
        <button class="button is-success" @click="uploadFile()" type="submit">
          Upload Csv
        </button>
      </v-row>
    </section>
    <section>
      <v-card>
        <v-card-title>
          <!-- Warehouse Franchisee Map List -->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-divider class="my-0" />
        <v-row class="pa-2">
          <v-col cols="3">
            <v-autocomplete
              name="kittype"
              v-model="franchiseeFilter"
              :items="franchiseeNameArray"
              key="id"
              item-text="name"
              item-value="name"
              @change="getFilteredData()"
            >
              <template v-slot:label> Franchisee </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              name="kittype"
              v-model="kitTypeFilter"
              :items="constantKit"
              key="id"
              item-text="id"
              item-value="id"
              @change="getFilteredData()"
            >
              <template v-slot:label> Kit Type </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-select
              @change="getFilteredData()"
              :items="warehouseNameArray"
              label="Warehouse"
              v-model="warehouseFilter"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              @change="getFilteredData()"
              :items="poTypeNameArray"
              label="POType"
              v-model="poTypeFilter"
            ></v-select>
          </v-col>
        </v-row>

        <v-data-table
          :headers="tableHeaders"
          :search="search"
          :items="franchiseeWarehouseMappingList"
        >
          <template v-slot:item.isActive="{ item }">
            <span
              v-if="item.isActive"
              class="is-medium tag is-success is-capitalized"
              >Active</span
            >
            <span v-else class="is-medium tag is-danger is-capitalized"
              >Inactive</span
            >
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              v-if="!item.isActive"
              class="px-2 ml-1 ma-1"
              color="info"
              min-width="0"
              small
              @click.prevent="restoreFranchiseeWHMapping(item.id)"
            >
              <v-icon small> mdi-restore</v-icon>
            </v-btn>
            <v-btn
              v-else
              class="px-2 ml-1 ma-1"
              color="error"
              min-width="0"
              small
              @click.prevent="restoreFranchiseeWHMapping(item.id)"
            >
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </section>
  </div>
</template>
<script>
// import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import _ from 'lodash'
export default {
  name: 'whMapping',
  components: {
    // CardComponent
  },

  data () {
    return {
      constantKit: _.filter(
        constants.KIT,
        (obj) => obj.isDisplayOnMapping === true
      ),
      uploadDialog: false,
      warehouseMapList: [],
      tableHeaders: [
        // { text: 'SrNo', value: 'id', sortable: true },
        {
          text: 'Franchisee',
          value: 'franchisee.companyName',
          sortable: false
        },
        {
          text: 'Warehouse',
          value: 'warehouseDetail.WareHouseName',
          sortable: false
        },
        { text: 'PO Type', value: 'poType', sortable: false },
        { text: 'Kit Type', value: 'kitType', sortable: false },
        { text: 'Priority', value: 'priority', sortable: false },
        { text: 'Status', value: 'isActive', sortable: false },
        { text: 'Action', value: 'action', sortable: false }
      ],
      search: '',
      loadingComponent: null,
      isLoading: false,
      franchiseeNameArray: [],
      franchiseeFilter: '',
      warehouseNameArray: [],
      warehouseFilter: '',
      poTypeNameArray: [],
      poTypeFilter: '',
      kitTypeFilter: '',
      franchiseeWarehouseMappingList: []
    }
  },
  created: function () {
    this.getWarehouseFranchiseeMapData()
  },
  methods: {
    getFilteredData: async function () {
      this.franchiseeWarehouseMappingList = this.warehouseMapList
      if (this.kitTypeFilter.length !== 0 || this.kitTypeFilter !== '') {
        console.log(this.kitTypeFilter)
        this.franchiseeWarehouseMappingList =
          this.franchiseeWarehouseMappingList.filter((map) => {
            return map.kitType
              .toLowerCase()
              .includes(this.kitTypeFilter.toLowerCase())
          })
      }
      if (this.franchiseeFilter.length !== 0 || this.franchiseeFilter !== '') {
        this.franchiseeWarehouseMappingList =
          this.franchiseeWarehouseMappingList.filter((map) => {
            return map.franchisee.companyName
              .toLowerCase()
              .includes(this.franchiseeFilter.toLowerCase())
          })
      }
      if (this.warehouseFilter.length !== 0 || this.warehouseFilter !== '') {
        this.franchiseeWarehouseMappingList =
          this.franchiseeWarehouseMappingList.filter((map) => {
            return map.warehouseDetail.WareHouseName.toLowerCase().includes(
              this.warehouseFilter.toLowerCase()
            )
          })
      }
      if (this.poTypeFilter.length !== 0 || this.poTypeFilter !== '') {
        this.franchiseeWarehouseMappingList =
          this.franchiseeWarehouseMappingList.filter((map) => {
            return map.poType
              .toLowerCase()
              .includes(this.poTypeFilter.toLowerCase())
          })
      }
    },
    clearFilters: async function () {
      // this.franchiseeFilter = ''
      // this.warehouseFilter = ''
      // this.poTypeFilter = ''
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    uploadFile () {
      this.$router.push({ name: 'warehouseMappingUpload' })
    },

    getWarehouseFranchiseeMapData: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/warehouseMapping`
        )
        this.warehouseMapList = data
        this.isLoading = false
        this.warehouseMapList = this.warehouseMapList.filter(function (item) {
          return item.franchisee !== null
        })
        this.franchiseeWarehouseMappingList = this.warehouseMapList
        this.franchiseeNameArray = [
          ...new Set(
            this.warehouseMapList.map((obj) => obj.franchisee.companyName)
          )
        ]
        this.warehouseNameArray = [
          ...new Set(
            this.warehouseMapList.map(
              (obj) => obj.warehouseDetail.WareHouseName
            )
          )
        ]
        this.poTypeNameArray = [
          ...new Set(this.warehouseMapList.map((obj) => obj.poType))
        ]
        await this.getFilteredData()
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    restoreFranchiseeWHMapping: async function (id) {
      let ref = this
      this.$dialog.warning({
        title: 'Restore Franchisee Warehouse Mapping',
        text: 'Do you want to restore Franchisee Warehouse Mapping?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async function () {
              try {
                ref.isLoading = true
                await http.post(
                  `${constants.API_URL}/api/warehouseMapping/restore/${id}`
                )
                ref.isLoading = false
                await ref.getWarehouseFranchiseeMapData()
                return ref.$dialog.info({
                  title: 'Success',
                  text: 'Franchisee Warehouse Mapping restored successfully!'
                })
              } catch (e) {
                console.log(e)
                ref.isLoading = false
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                console.log(
                  'error in restoring Franchisee Warehouse Mapping : ',
                  errorMessage
                )
                return ref.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              }
            }
          }
        }
      })
    }
  }
}
</script>
<style scoped>
table,
th,
td {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
  padding: 0.65rem 0.7rem;
  font-size: 1rem;
}
table {
  overflow-x: scroll;
  overflow-y: scroll;
}
td {
  display: table-cell;
  padding: 5px;
  color: black;
}
th {
  color: #fff;
  background-color: #56509f;
}
.hidden {
  display: none;
}
.statusCode {
  font-style: italic;
  font-weight: 600;
}
</style>
